import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";

/**
 * Sun/moon toggle used in nav headers.
 * - Uses sage accent for visual continuity.
 * - Respects reduced motion (no rotate animation when prefers-reduced-motion).
 */
export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle"
      className={`inline-flex items-center justify-center w-9 h-9 rounded-md border border-[var(--rg-border)] bg-[var(--rg-surface)] text-[var(--rg-text)] hover:text-[var(--rg-sage)] hover:border-[var(--rg-sage)] transition-fast ${className}`}
      type="button"
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}

export default ThemeToggle;
